import React from 'react'
import AsSeenIn from './AsSeenIn'

export default () => {
    return (
            <AsSeenIn/>
           )
}
